import Layout from '@/components/layout/index.vue'

export default {
  path: 'ordersupplier',
  name: 'Ordersupplier',
  meta: {},
  component: Layout,
  redirect: { name: 'Ordersupplier.Orderchange' },
  children: [{
    path: 'orderchange',
    name: 'Ordersupplier.Orderchange',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "ordersupplier" */ '@/views/supplier/ordersupplier/orderchange/index.ts')
  },
  {
    path: 'closingorder',
    name: 'Ordersupplier.Closingorder',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "ordersupplier" */ '@/views/supplier/ordersupplier/closingorder/index.ts')
  },
  {
    path: 'ordertrack',
    name: 'Ordersupplier.Ordertrack',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "ordersupplier" */ '@/views/supplier/ordersupplier/ordertrack/index.ts')
  },
  {
    path: 'orderreply',
    name: 'Ordersupplier.Ordertrack.Orderreply',
    meta: { title: 'ordersupplier.ordertrack.orderreply', dep: 'Ordersupplier.Ordertrack' },
    component: () =>
                import(/* webpackChunkName: "ordersupplier" */ '@/views/supplier/ordersupplier/ordertrack/orderreply.ts')
  },
  {
    path: 'labelprinting',
    name: 'Ordersupplier.Labelprinting',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "orderpurchase" */ '@/views/purchaser/orderpurchase/labelprinting/index.ts')
  },
  {
    path: 'purchasereply',
    name: 'Ordersupplier.Purchasereply',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "orderpurchase" */ '@/views/purchaser/orderpurchase/purchasereply/index.ts')
  },
  {
    path: 'outorderissue',
    name: 'Ordersupplier.Outorderissue',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "ordersupplier" */ '@/views/purchaser/orderpurchase/outorderissue/index.ts')
  },
  {
    path: 'externalcontrol',
    name: 'Ordersupplier.Externalcontrol',
    meta: {},
    component: () =>
                import(/* webpackChunkName: "ordersupplier" */ '@/views/supplier/ordersupplier/externalcontrol/index.ts')
  },
  {
    path: 'externalcontrol/add',
    name: 'Ordersupplier.Externalcontrol.Add',
    meta: { title: 'common.add', dep: 'Ordersupplier.Externalcontrol' },
    component: () =>
                import(/* webpackChunkName: "ordersupplier" */ '@/views/supplier/ordersupplier/externalcontrol/add.ts')
  },
  {
    path: 'externalcontrol/modify/:checkApplyNo',
    name: 'Ordersupplier.Externalcontrol.Modify',
    meta: { title: 'common.modify', dep: 'Ordersupplier.Externalcontrol' },
    component: () =>
                import(/* webpackChunkName: "ordersupplier" */ '@/views/supplier/ordersupplier/externalcontrol/modify.ts')
  }
  ]
}
